<template>
    <div>
        <app-bar
                :backTo="back_to"
        ></app-bar>

        <v-card tile>
            <v-list
                    three-line
                    subheader
            >
                <v-subheader>Impostazioni</v-subheader>
                <v-list-item>
                    <v-list-item-content class="pr-4">
                        <v-list-item-title>Geolocalizzazione</v-list-item-title>
                        <v-list-item-subtitle>
                            <small>Per migliorare i risultati di ricerca, consigliamo di attivare la
                                geolocalizzazione.
                            </small>
                        </v-list-item-subtitle>
                    </v-list-item-content>
                    <v-switch v-model="notifications"></v-switch>
                </v-list-item>

                <v-divider></v-divider>

                <v-list-item>
                    <v-list-item-content class="pr-4">
                        <v-list-item-title>Geolocalizzazione</v-list-item-title>
                        <v-list-item-subtitle>
                            <small>Per migliorare i risultati di ricerca, consigliamo di attivare la
                                geolocalizzazione.
                            </small>
                        </v-list-item-subtitle>
                    </v-list-item-content>
                    <v-switch v-model="notifications"></v-switch>
                </v-list-item>

            </v-list>
        </v-card>

    </div>
</template>

<script>
    import axios from 'axios';
    import {mapMutations, mapActions} from 'vuex'

    export default {
        name: "settings",
        props: {
            back_to: Object,
        },
        data() {
            return {
                notifications: false
            }
        },
        created() {
            navigator.permissions.query({name: 'geolocation'}).then(resp => {
                    this.notifications = resp.state;
                }
            );
            console.log(this.notifications);
        },
        methods: {
            ...mapMutations([
                'setLoading',
            ]),
            ...mapActions([]),
        }
    }
</script>

<style scoped>

</style>